// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1tWIv","author":"Table_author__3sK3d","authorImage":"Table_authorImage__1DRTK","unreadRow":"Table_unreadRow__3sNj5"};